import React from 'react';

import PropTypes from 'prop-types';

import { Container } from './styles';
const HeaderTotalGraphicLight = ({ title, description, small, marginBottom }) => {
    return (
        <Container small={small} marginBottom={marginBottom}>
            <h1>{title}</h1>
            <h2>{description}</h2>
        </Container>
    );
};

HeaderTotalGraphicLight.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    marginBottom: PropTypes.string,
    small: PropTypes.bool
};

export default HeaderTotalGraphicLight;
